<template>
  <div>
    <v-dialog
      v-model="isCreateSolicitanteDialogOpen"
      max-width="800px"
      persistent
    >
      <configurar-solicitante-card
        :solicitante-id="0"
        :close-dialog="() => { isCreateSolicitanteDialogOpen = false }"
      />
    </v-dialog>

    <v-dialog
      v-model="isInfoDialogOpen"
      max-width="800px"
      persistent
    >
      <v-card class="pa-sm-10 pa-3">
        <btn-close-dialog :handle-click="closeDialog" />

        <v-card-title class="justify-center text-h6">
          Criar Ticket
        </v-card-title>

        <v-card-text class="mt-2">
          <v-form
            ref="formRef"
            class="multi-col-validation"
            @submit.prevent="handleSubmit"
          >
            <v-select
              v-model="requestData.tipoSolicitacaoId"
              class="mb-6"
              dense
              outlined
              hide-details
              no-data-text="Sem dados"
              label="Tipo de Solicitação"
              item-text="nome"
              item-value="id"
              :items="tiposDeSolicitacoes"
              :rules="[validators.select]"
              @click="getTiposDeSolicitacoes"
            />

            <v-divider></v-divider>

            <p class="font-weight-semibold payment-details-header mt-2">
              Dados do Solicitante
            </p>

            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  :value="solicitanteData"
                  dense
                  outlined
                  clearable
                  :item-text="getAutocompleteItemText"
                  return-object
                  label="Procurar"
                  placeholder="Comece a digitar para pesquisar"
                  no-data-text="Dados não localizados"
                  validate-on-blur
                  :rules="[v => Object.values(v).some(it => !!it) ? true : 'Este campo é obrigatório']"
                  :items="solicitantes"
                  :loading="isSearchLoading"
                  :search-input.sync="search"
                  @change="selectAutocompleteSolicitante"
                  @click.clear="items = []"
                >
                  <template #prepend-item>
                    <v-expand-transition>
                      <div
                        v-if="search && !solicitantes.length"
                        class="pl-5 mt-2 mb-4"
                        @click="isCreateSolicitanteDialogOpen = !isCreateSolicitanteDialogOpen"
                      >
                        <span>
                          <a>Deseja criar cadastro?</a>
                        </span>
                      </div>
                    </v-expand-transition>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  :value="solicitanteData.nome"
                  dense
                  outlined
                  label="Nome"
                  placeholder="Nome"
                  hide-details="auto"
                  disabled
                  filled
                />
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-mask="'###.###.###-##'"
                  :value="solicitanteData.cpf"
                  dense
                  outlined
                  label="CPF"
                  placeholder="CPF"
                  hide-details="auto"
                  disabled
                  filled
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  :value="solicitanteData.email"
                  dense
                  outlined
                  type="email"
                  label="E-mail selecionado"
                  placeholder="E-mail"
                  hide-details="auto"
                  disabled
                  filled
                />
              </v-col>

              <!-- <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-mask="'(##) #####-####'"
                  :value="solicitanteData.celular"
                  dense
                  outlined
                  label="Celular"
                  placeholder="Celular"
                  hide-details="auto"
                  disabled
                  filled
                />
              </v-col> -->
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="requestData.titulo"
                  dense
                  outlined
                  label="Assunto"
                  placeholder="Assunto"
                  hide-details="auto"
                  validate-on-blur
                  :rules="[validators.required]"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="requestData.conteudoTexto"
                  dense
                  outlined
                  no-resize
                  label="Mensagem"
                  placeholder="Mensagem"
                  hide-details="auto"
                  validate-on-blur
                  :rules="[validators.required]"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <file-input-com-data-table
                  label="Adicionar anexos"
                  no-data-message="Nenhum anexo adicionado"
                  :lista-de-arquivos.sync="requestData.anexos"
                  :tamanho-maximo-arquivo-mb="TAMANHO_MAXIMO_ARQUIVO_MB"
                  :loading="loading"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                class="d-flex justify-center"
              >
                <v-btn
                  color="primary"
                  class="mr-4"
                  type="submit"
                  :disabled="loading"
                >
                  <v-progress-circular
                    v-if="loading"
                    class="mx-4"
                    indeterminate
                    color="secundary"
                  />
                  <span v-else>Criar</span>
                </v-btn>

                <v-btn
                  color="secondary"
                  class="mb-1"
                  outlined
                  type="reset"
                  :disabled="loading"
                  @click="closeDialog"
                >
                  {{ resetBtnTitle }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>

          <v-col
            cols="12"
            class="d-flex justify-center"
          >
            <v-alert
              v-if="mensagemDeSucesso"
              class="mt-4"
              dense
              dismissible
              type="success"
            >
              {{ mensagemDeSucesso }}
            </v-alert>

            <v-alert
              v-else-if="mensagemDeErro"
              class="mt-4"
              shaped
              outlined
              type="error"
            >
              {{ mensagemDeErro }}
            </v-alert>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 5px;
  font-family: calibri;
}
</style>

<script>
import Vue from 'vue'
import { ref, watch } from '@vue/composition-api'
import { required, select } from '@core/utils/validation'
import BtnCloseDialog from '@/components/btn-close-dialog/BtnCloseDialog.vue'
import FileInputComDataTable from '@/components/file-input/FileInputComDataTable.vue'
import ConfigurarSolicitanteCard from '../solicitante/ConfigurarSolicitanteCard.vue'
import FilaService from '@/services/modules/FilaService'
import ClienteService from '@/services/modules/ClienteService'
import TicketService from '@/services/modules/TicketService'
import SolicitanteDataModel from './SolicitanteDataModel'
import AberturaManualCommand from '@/models/commands/AberturaManualCommand'
import useForm from '@/composables/useForm'

export default {
  components: {
    BtnCloseDialog,
    FileInputComDataTable,
    ConfigurarSolicitanteCard,
  },

  props: {
    filaId: {
      type: Number,
      required: true,
    },
    isInfoDialogOpen: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const requestData = ref(new AberturaManualCommand(props.filaId))
    const solicitanteData = ref(new SolicitanteDataModel())
    const isCreateSolicitanteDialogOpen = ref(false)
    const search = ref('')
    const isSearchLoading = ref(false)
    const solicitantes = ref([])
    const tiposDeSolicitacoes = ref([])

    const mensagemDeSucesso = ref('')
    const mensagemDeErro = ref('')
    const resetBtnTitle = ref('Cancelar')

    const { formRef, loading } = useForm()

    const TAMANHO_MAXIMO_ARQUIVO_MB = 3

    async function getTiposDeSolicitacoes() {
      if (tiposDeSolicitacoes.value.length) return
      tiposDeSolicitacoes.value = await FilaService.getTiposDeSolicitacoesDisponiveisParaAberturaManual(requestData.value.filaId)
    }

    async function handleSearchChange() {
      if (isSearchLoading.value) return
      try {
        isSearchLoading.value = true
        solicitantes.value = await ClienteService.getSolicitanteByQuery(search.value)
      } finally {
        isSearchLoading.value = false
      }
    }
    watch(() => search.value, v => {
      if (!v) {
        solicitantes.value = []
      } else {
        handleSearchChange()
      }
    })

    function getAutocompleteItemText(item) {
      let str = `${item.id}, ${item.nome}`

      if (item.email) {
        str += `, ${item.email}`
      }
      if (item.cpf) {
        str += `, ${item.cpf}`
      }

      return str
    }

    function selectAutocompleteSolicitante(solicitante) {
      solicitanteData.value = solicitante || new SolicitanteDataModel()
      requestData.value.solicitanteId = solicitanteData.value.id
      requestData.value.solicitanteEmail = solicitanteData.value.email
    }

    function resetRequestData() {
      requestData.value = new AberturaManualCommand(props.filaId)
      solicitanteData.value = new SolicitanteDataModel()

      mensagemDeSucesso.value = ''
      mensagemDeErro.value = ''
      resetBtnTitle.value = 'Cancelar'

      formRef.value.reset()
    }

    function closeDialog() {
      resetRequestData()

      mensagemDeSucesso.value = ''
      mensagemDeErro.value = ''
      resetBtnTitle.value = 'Cancelar'

      emit('update:is-info-dialog-open', false)
    }

    async function criarTicket() {
      if (loading.value) return

      try {
        loading.value = true

        const { protocolo } = await TicketService.criarTicketManual(requestData.value)
        navigator.clipboard.writeText(protocolo)

        emit('refetch-data')
        resetRequestData()

        mensagemDeSucesso.value = `Ticket criado com sucesso! Número do protocolo: ${protocolo}`
        resetBtnTitle.value = 'Fechar'
      } catch (err) {
        mensagemDeErro.value = err.response.data.message
      } finally {
        loading.value = false
      }
    }
    async function handleSubmit() {
      if (loading.value) return
      if (formRef.value.validate()) {
        await criarTicket()
      } else {
        Vue.$toast.warning('Preencha corretamente os campos antes de salvar')
      }
    }

    return {
      requestData,
      solicitanteData,
      isCreateSolicitanteDialogOpen,
      tiposDeSolicitacoes,
      getTiposDeSolicitacoes,
      search,
      isSearchLoading,
      solicitantes,
      getAutocompleteItemText,
      selectAutocompleteSolicitante,
      mensagemDeSucesso,
      mensagemDeErro,
      resetBtnTitle,
      formRef,
      loading,
      closeDialog,
      handleSubmit,
      TAMANHO_MAXIMO_ARQUIVO_MB,

      validators: {
        required,
        select,
      },
      SolicitanteDataModel,
    }
  },
}
</script>
